import type { RefObject } from 'react'

import { ATTACHMENT_ACCEPT } from './attachments'

/**
 * 选文件用的那个 input，藏起来。
 *
 * **藏起来而不是画出来**：设计稿的工具条上是一颗「附件」按钮，
 * 不是一个原生的 file input（它长什么样各浏览器不同，且改不了）。
 * `accept` 从白名单派生（attachments.ts），不另写一份——
 * 两份分家的表现是「我明明选得中，它却说不行」。
 * 选完立刻把 value 清空：不清的话，连着选同一个文件两次
 * 第二次不会触发 change，而用户会以为按钮坏了。
 *
 * 主屏与项目页共用这一个，理由与 use-conversation-workbench.ts 顶上那段相同。
 */
export function HiddenAttachmentInput({
  inputRef,
  onPick,
}: {
  readonly inputRef: RefObject<HTMLInputElement | null>
  readonly onPick: (files: File[]) => void
}) {
  return (
    <input
      ref={inputRef}
      type="file"
      multiple
      accept={ATTACHMENT_ACCEPT}
      data-testid="lulu-attach-input"
      className="hidden"
      onChange={(e) => {
        const picked = Array.from(e.target.files ?? [])
        e.target.value = ''
        if (picked.length > 0) onPick(picked)
      }}
    />
  )
}
